import React, { cloneElement, Children, isValidElement } from 'react';
import type TTabs from './types/TTabs';
import Box from '../Box/Box';
import keyboardKeys from '../../constants/keyboardKeys';

/**
 * TODO: We should change the implementation of this component and remove Children.map
 * https://react.dev/reference/react/Children#accepting-an-array-of-objects-as-a-prop
 */

const Tabs = ({ children, setActiveTab, activeTab = 0, isFluid, ...otherProps }: TTabs) => {
  const { ARROW_RIGHT, ARROW_LEFT, ENTER } = keyboardKeys;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    const tabs = React.Children.toArray(children);
    const currentIndex = activeTab;
    let nextIndex;

    switch (event.key) {
      case ARROW_RIGHT:
        event.preventDefault();
        nextIndex = (currentIndex + 1) % tabs.length; // wrap around to the beginning of the tab list if the incremented index exceeds the number of tabs.
        setActiveTab?.(nextIndex);
        break;
      case ARROW_LEFT:
        event.preventDefault();
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        setActiveTab?.(nextIndex);
        break;
      case ENTER:
      case ' ':
        event.preventDefault();
        setActiveTab?.(currentIndex);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      as="ol"
      name="TabsNext"
      modifiers={isFluid ? ['fluid'] : []}
      role="tablist"
      onKeyDown={handleKeyDown}
      {...otherProps}
    >
      {Children.map(children, (tab, tabIdx) => {
        return (
          isValidElement(tab) &&
          cloneElement(tab, {
            isActive: tabIdx === activeTab,
            onClick: setActiveTab && (() => setActiveTab(tabIdx)),
            ...tab.props,
            id: tabIdx,
          })
        );
      })}
    </Box>
  );
};

export default Tabs;
